webpackJsonp([116921297405540],{

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(134);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Add Pagination Metadata'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll add pagination information to our collections, so components can tell how many pages of data are available.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'pagination.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Pagination Metadata'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In order to implement pagination, we need to know some information about the tweets we\'re viewing, such as:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'How many tweets exist'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'How many tweets are provided on each page'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we look at the API response from the server, we can see that that information is provided in the response as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta.paginate'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        data: [\n          {...tweet...},\n          {...tweet...}\n        ],\n        meta: {\n          paginate: {\n            currentPage: 1,\n            nextPage: 2,\n            prevPage: null,\n            totalPages: 11,\n            totalCount: 51,\n            perPage: 5\n          }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'What we want to do is make that information available to the application, so we can calculate the number of pages to display.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Pagination Data to Collections'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that open up ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/connections.js'
	      ),
	      ' and find the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'collections'
	      ),
	      '. Update that method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/connections.js\n      ...\n        collections: {\n          properties: {\n            parse: function(response) {\n              this.meta = {\n                totalCount: response.meta.paginate.totalCount,\n                perPage: response.meta.paginate.perPage\n              };\n              return response.data;\n            }\n          }\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Collections in Lore have a special property called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta'
	      ),
	      '. It defaults to an empty object, and anything you add to it will show up in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta'
	      ),
	      ' property of the data structure for collections.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By adding ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'totalCount'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'perPage'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta'
	      ),
	      ', we\'ve now made that data available to any component that receives a collection.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this. Exactly the same :)'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'config/connections.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/connections.js\n      import auth from \'../src/utils/auth\';\n\n      export default {\n\n        default: {\n\n          apiRoot: \'http://localhost:1337\',\n\n          headers: function() {\n            return {\n              Authorization: `Bearer ${auth.getToken()}`\n            };\n          },\n\n          collections: {\n            properties: {\n              parse: function(response) {\n                this.meta = {\n                  totalCount: response.meta.paginate.totalCount,\n                  perPage: response.meta.paginate.perPage\n                };\n                return response.data;\n              }\n            }\n          }\n\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next step we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'paginate the feed'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-pagination-step-1-js-663a534f594beb8df381.js